// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"261":"ce37df86","446":"be7b9358","805":"2e3c599a"}[chunkId] + ".js";
};